import { Component, Input, OnInit, EventEmitter, SimpleChange, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from './models/question-base.model';
import { Observable, Subscription, Subject } from 'rxjs/';
import { ConfigService } from 'app/core/services/config.service';
import { UtilService } from 'app/core/services/util.service';
import { UploaderService } from '../uploader/uploader.service';
@Component({
    selector: "itpx-form-question",
    templateUrl: "form-question.component.html",
    styleUrls: ["form-question.component.css"],
})
export class FormQuestionComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() form: FormGroup;
    @Input() change: EventEmitter<any>;
    @Output() unsavedData = new Subject();
    @Output() actionClicked = new EventEmitter<any>();

    private errorMessage: string = "is required";
    private dimensions = {width: 640, height: 480, comp: 'geq', ratio: 4 / 3};

    file: File;
    uploadsBucket = this.configService.get("aws").uploadsBucket;
    private isFileUploading = {};
    private signatureKey = {};
    private signatureErrorMsg = {};

    constructor(
        private configService: ConfigService,
        private utilService: UtilService,
        private uploaderService: UploaderService
    ) {}

    ngOnInit() {
        this.form.valueChanges.subscribe((data) => {
            this.change.emit(data);
        });
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        this.form.valueChanges.subscribe((data) => {
            this.unsavedData.next(true);
        });
    }

    get isValid() {
        if (this.question["trim"]) {
            if (this.form.controls[this.question.key].value)
                this.form.controls[this.question.key].patchValue(
                    this.form.controls[this.question.key].value.trim()
                );
        }
        if (this.question["disabled"]) {
            this.form.controls[this.question.key].disable();
        }

        if (
            this.form.controls[this.question.key].errors &&
            this.form.controls[this.question.key].errors.pattern
        ) {
            this.errorMessage = "is not in a valid format";
        } else if (
            this.form.controls[this.question.key].errors &&
            this.form.controls[this.question.key].errors.maxlength
        ) {
            this.errorMessage =
                "is exceeding the limit of " +
                this.question["maxlength"] +
                " characters";
        } else if (
            this.form.controls[this.question.key].errors &&
            this.form.controls[this.question.key].errors.custom && 
            this.form.controls[this.question.key].errors.custom.message
        ) {
            let message = this.form.controls[this.question.key].errors.custom.message;
            if (this.form.controls[this.question.key].pristine || (this.question.value == this.form.controls[this.question.key].value)) {
                this.form.get(this.question.key).setErrors(null);
            } else {
                let alreadyExistsMessage = "already exists";
                if (~message.indexOf(alreadyExistsMessage)) {
                    this.errorMessage = alreadyExistsMessage;
                } else {
                    this.errorMessage = message;
                }
            }
        } else {
            this.errorMessage = "is required";
        }

        if (this.question["controlType"] == "checkbox") {
            if (
                this.question["required"] &&
                (this.form.controls[this.question.key].value == null ||
                    this.form.controls[this.question.key].value == false)
            ) {
                this.form.controls[this.question.key].setErrors({
                    incorrect: true,
                });
            }
        }

        return (
            this.form.controls[this.question.key].valid ||
            this.form.controls[this.question.key].pristine
        );
    }

    private onFileChange(event: any, formKey: string) {
        this.signatureErrorMsg[formKey] = "";
        this.file = event.target.files[0] || event.srcElement.files[0];
        this.isFileUploading[formKey] = true;
        //NOTE: The following condition prevents scanning of files > 10MB
        //It is necessary because it prevents blovking the event loop and breaking the browser
        if (this.file.size < 20 * 1024 * 1024 && this.validateFile(this.file, formKey)) {
            this.validateDimensions(this.file, formKey).then((result) => {
                if (result) {
                    const ext = this.file.name.split(".").pop();
                    const key = this.utilService.guid() + "." + ext;
                    this.uploaderService
                        .uploadContent(this.file, key, this.uploadsBucket)
                        .subscribe(
                            (data) => {
                                if (data.completed) {
                                    this.isFileUploading[formKey] = false;
                                    this.signatureKey[formKey] = data.key;
                                    this.form.patchValue({
                                        signatureKey: data.key,
                                        signatureBucket: data.bucket,
                                    });
                                }
                            },
                            (error) => {},
                            () => {
                                this.isFileUploading[formKey] = false;
                            }
                        );
                } else {
                    this.invalidSignatureErr(formKey);
                }
            });
        } else {
            this.invalidSignatureErr(formKey);
        }
    }

    private invalidSignatureErr(formKey: string) {
        this.isFileUploading[formKey] = false;
            if (!this.signatureErrorMsg[formKey]) {
                this.signatureErrorMsg[formKey] = "Provide valid signature";
            }
    }

    private validateFile(file: File, key: string): boolean {
        let fileNameSplit = file.name.split(".");
        let fileExtension = fileNameSplit[fileNameSplit.length - 1];
        if (["png", "jpg", "jpeg"].indexOf(fileExtension) >= 0) {
            return true;
        }
        this.signatureErrorMsg[key] = "Invalid file extension";
        return false;
    }

    private validateDimensions(file: File, key: string) {
        let img = new Image();
        img.src = window.URL.createObjectURL(file);
        return new Promise((res, rej) => {
            img.onload = () => {
              let result: boolean = (!this.dimensions.height || this.dimensions.height <= img.naturalHeight)
                          && (!this.dimensions.width || this.dimensions.width <= img.naturalWidth);
                 
              if (this.dimensions.ratio)
                  result = result && ((img.naturalWidth / img.naturalHeight) < this.dimensions.ratio + 0.1) && ((img.naturalWidth / img.naturalHeight) > this.dimensions.ratio - 0.1)
    
              if (!result) {
                this.signatureErrorMsg[key] = "Invalid file resolution";
                res(false);
              }
              res(true);
          }
        });
    }

    private onActionClicked(item: any, action: string) {
        this.actionClicked.emit({ action, item });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/form/form-question.component.ts